export const materias = [
    { materia: 'Análisis Matemático I', nivel: 1, horas: 5 },
    { materia: 'Algebra y G. Analítica', nivel: 1, horas: 5 },
    { materia: 'Matemática Discreta', nivel: 1, horas: 3 },
    { materia: 'Sistemas y Organizaciones (Int.)', nivel: 1, horas: 3 },
    { materia: 'Algoritmos y Est. de Datos', nivel: 1, horas: 5 },
    { materia: 'Arquitectura de Computadoras', nivel: 1, horas: 4 },
    { materia: 'Física I', nivel: 1, horas: 5 },
    { materia: 'Inglés I', nivel: 1, horas: 2 },
    //fin primero
    { materia: 'Química', nivel: 2, horas: 3 },
    { materia: 'Análisis Matemático II', nivel: 2, horas: 5 },
    { materia: 'Física II', nivel: 2, horas: 5 },
    { materia: 'Análisis de Sistemas (Int.)', nivel: 2, horas: 6 },
    { materia: 'Sintaxis y Semántica de los Lenguajes', nivel: 2, horas: 4 },
    { materia: 'Paradigmas de Programación', nivel: 2, horas: 4 },
    { materia: 'Sistemas Operativos', nivel: 2, horas: 4 },
    { materia: 'Sistemas de Representación', nivel: 2, horas: 3 },
    //fin segundo
    { materia: 'Probabilidades y Estadísticas', nivel: 3, horas: 3 },
    { materia: 'Diseño de Sistemas (Int.)', nivel: 3, horas: 6 },
    { materia: 'Comunicaciones', nivel: 3, horas: 4 },
    { materia: 'Matemática Superior', nivel: 3, horas: 4 },
    { materia: 'Gestión de Datos', nivel: 3, horas: 2 },
    { materia: 'Ingeniería y Sociedad', nivel: 3, horas: 3 },
    { materia: 'Economía', nivel: 3, horas: 2 },
    { materia: 'Inglés II', nivel: 3, horas: 4 },
    //fin tercero
    { materia: 'Redes de Información', nivel: 4, horas: 4 },
    { materia: 'Administración de Recursos (Int.)', nivel: 4, horas: 6 },
    { materia: 'Investigación Operativa', nivel: 4, horas: 5 },
    { materia: 'Simulación', nivel: 4, horas: 4 },
    { materia: 'Ingeniería de software', nivel: 4, horas: 3 },
    { materia: 'Teoría de Control', nivel: 4, horas: 3 },
    { materia: 'Legislación', nivel: 4, horas: 2 },
    //fin cuarto
    { materia: 'Proyecto Final (Int.)', nivel: 5, horas: 6 },
    { materia: 'Inteligencia Artificial', nivel: 5, horas: 3 },
    { materia: 'Administración Gerencial', nivel: 5, horas: 3 },
    { materia: 'Sistemas de Gestión', nivel: 5, horas: 4 },
    //fin quinto
    { materia: 'Complejidad y Técnicas de Diseño de Algoritmos (Elec.)', nivel: 2, horas: 3, electiva:true },
    { materia: 'Planificación(Elec.) ', nivel: 3, horas: 3, electiva:true},
    { materia: 'Bases De Datos Aplicadas (Elec.)', nivel: 3, horas: 4, electiva:true },
    { materia: 'Desarrollo de Aplicaciones Cliente Servidor (Elec.)', nivel: 4, horas: 4, electiva:true },
    { materia: 'Sistemas de Información Geográficos (Elec.)', nivel: 4, horas: 4, electiva:true },
    { materia: 'Calidad del Producto y del Proceso Software (Elec.)', nivel: 4, horas: 4, electiva:true },
    { materia: 'Técnicas de Desarrollo de Software Ágil (Elec.)', nivel: 4, horas: 4, electiva:true },
    { materia: 'Gestión de Seguridad de la Información (Elec.)', nivel: 5, horas: 4, electiva:true },
    { materia: 'Auditoría de Sistemas e Informática Forense (Elec.)', nivel: 5, horas: 4, electiva:true },
    { materia: 'Integración de desarrollo y operación de Software (Elec.)', nivel: 5, horas: 4, electiva:true },
    { materia: 'Sistemas de Inteligencia de Negocios y Soporte de Decisiones (Elec.)', nivel: 5, horas: 4, electiva:true },
    { materia: 'Formación de Emprendedores (Elec.)', nivel: 5, horas: 4, electiva:true },
    { materia: 'Fundamentos de Ciberseguridad (Elec.)', nivel: 5, horas: 4, electiva:true },
    { materia: 'Desarrollo de Videojuegos (Elec. No Se Dicta)', nivel: 5, horas: 4, electiva:true },
    { materia: 'Programación Competitiva (Elec. No Se Dicta )', nivel: 5, horas: 4, electiva:true },
];